import { Divider, Input, InputNumber, Row } from "antd";
import ResponsiveCol from "../../../../common/components/form/ResponsiveCol";
import Validations from "./DistributionPointValidations";
import tooltipList from "../tooltip.json";
import { DistributionPointRequestResource } from "api/generated";
import { FormItem } from "common/components/form/FormItem";
import { ExtraInfoBtn } from "common/helpers/generalUtils";

function AddressDataForm() {
  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", color: "#606676" }}
      >
        Domicilio fiscal
      </Divider>
      <Row gutter={24}>
        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Calle"
            name="street"
            rules={Validations.StreetRules}
          >
            <Input
              className="common-input"
              placeholder="Nombre de la calle"
              addonAfter={ExtraInfoBtn("Introduce el nombre de la calle", [
                tooltipList.domicilioFiscal.calle,
              ])}
            />
          </FormItem>
        </ResponsiveCol>
        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Número"
            name="number"
            rules={Validations.StreetNumberRules}
          >
            <Input
              className="common-input"
              placeholder="Número de la calle"
              addonAfter={ExtraInfoBtn("Introduce el número de la calle", [
                tooltipList.domicilioFiscal.numero,
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Número Interior"
            name="insideNumber"
            rules={Validations.StreetInsideNumberRules}
          >
            <Input
              className="common-input"
              placeholder="Número interior"
              addonAfter={ExtraInfoBtn("Introduce el número interior", [
                tooltipList.domicilioFiscal.numeroInterior,
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Colonia"
            name="colony"
            rules={Validations.ColonyRules}
          >
            <Input
              className="common-input"
              placeholder="Nombre de la colonia"
              addonAfter={ExtraInfoBtn("Introduce el nombre de la colonia", [
                tooltipList.domicilioFiscal.colonia,
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Código postal"
            name="postalCode"
            rules={Validations.ZipCodeRules}
          >
            <Input
              className="common-input"
              placeholder="Código postal"
              addonAfter={ExtraInfoBtn("Introduce el código postal", [
                tooltipList.domicilioFiscal.codigoPostal,
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Estado"
            name="state"
            rules={Validations.StateRules}
          >
            <Input
              className="common-input"
              placeholder="Estado"
              addonAfter={ExtraInfoBtn("Introduce el Estado", [
                tooltipList.domicilioFiscal.estado,
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<DistributionPointRequestResource>
            label="Municipio"
            name="municipality"
            rules={Validations.MunicipalityRules}
          >
            <Input
              className="common-input"
              placeholder="Municipio"
              addonAfter={ExtraInfoBtn("Introduce el municipio", [
                tooltipList.domicilioFiscal.municipio,
              ])}
            />
          </FormItem>
        </ResponsiveCol>
      </Row>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", color: "#606676" }}
      >
        Geolocalización
      </Divider>
      <Row gutter={24}>
        <ResponsiveCol size="lg">
          <FormItem<DistributionPointRequestResource>
            label="Latitud"
            name="latitude"
            rules={Validations.LatitudeRules}
          >
            <InputNumber
              className="common-input"
              precision={7}
              style={{ width: "100%" }}
              placeholder="Latitud de la ubicación de la planta"
              addonAfter={ExtraInfoBtn(
                "Introduce o selecciona la latitud de la ubicación de la planta",
                [tooltipList.domicilioFiscal.geolocalizacion.latitud]
              )}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol size="lg">
          <FormItem<DistributionPointRequestResource>
            label="Longitud"
            name="longitude"
            rules={Validations.LongitudeRules}
          >
            <InputNumber
              className="common-input"
              style={{ width: "100%" }}
              precision={7}
              placeholder="Longitud de la ubicación de la planta"
              addonAfter={ExtraInfoBtn(
                "Introduce o selecciona la longitud de la ubicación de la planta",
                [tooltipList.domicilioFiscal.geolocalizacion.longitud]
              )}
            />
          </FormItem>
        </ResponsiveCol>
      </Row>
    </div>
  );
}

export default AddressDataForm;
